// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";
import { TabDto } from "./tab-dto";

export class TabsDto extends ItiBaseDto {
	public option: string;
	public tabs: TabDto[];

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
